import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles({
  root: {
    background: '#1A2455',
    height: 220,
    padding: '25px 15px',
    borderRadius: 12,
    boxShadow: '0 0 5px 5px rgba(0,0,0,.1)',
    position: 'relative',
    top: 10,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left'
  },
  pointrLogo: {
    height: 28
  },
  text: {
    color: '#fffbfb',
    fontSize: 14,
    fontWeight: 300,
    marginTop: 15,
    paddingRight: 35
  },
  createButton: {
    background: '#3687f4',
    color: 'white',
    height: 28,
    marginTop: 20,
    '&:hover': {
      cursor: 'pointer',
      color: '#3687f4',
      background: 'white'
    }
  },
  createButtonText: {
    fontSize: 13
  }
})
